import { MindboxTracker } from './mindbox-tracker';

export class MindboxOperation {
    constructor() {
        this.mindboxTracker = new MindboxTracker();
    }

    setCart() {
        let _self = this;
        $.ajax({
            url: '/ajax/action/widget_mindbox_operation_basket/get_data/',
            type: 'GET',
            success: function(result) {
                if (parseInt(result.code) === 200) {
                    _self.mindboxTracker.setCart(result.data);
                }
            }
        });
    }

    setWishList() {
        let _self = this;
        $.ajax({
            url: '/ajax/action/widget_mindbox_operation_favorite/get_data/',
            type: 'GET',
            success: function(result) {
                if (parseInt(result.code) === 200) {
                    _self.mindboxTracker.setWishList(result.data);
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./modules/mindbox/mindbox-operation.js